/**
 * [Insider+] API Request Functions
 *
 * SSO token + benefits operations for Insider+ authentication.
 */

import { getRequest, postRequest, replaceInUrl } from './index';
import apiEndpoints from './apiEndpoints';

/**
 * Issue a new SSO token for the current authenticated user
 * @returns {Promise} SSO token response
 */
export const issueSsoToken = () =>
  getRequest(apiEndpoints.insiders.issueSsoToken);

/**
 * Validate an SSO token
 * @param {string} ssoToken - The SSO token to validate
 * @returns {Promise} Validation response
 */
export const validateSsoToken = (ssoToken) =>
  postRequest(apiEndpoints.insiders.validateSsoToken, { ssoToken });

/**
 * Fetch Insider+ benefits (subscription status, etc.) for a user
 * @param {string} userUid
 * @returns {Promise} benefits response
 */
export const getInsiderBenefits = (userUid) =>
  getRequest(replaceInUrl(apiEndpoints.insiders.getBenefits, { userUid }));
